/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Compose Agent A-owned workspace section actions without changing shared routes.
 * @state-owner Agent A feature modules
 * @allowed-imports Agent A module public APIs; shared composition contract
 * @forbidden Agent B modules; routes; direct API clients
 * @public-api WorkspaceSectionActions aggregator
 * @side-effects delegated to rendered feature actions
 * @tests WorkspaceSectionActions.test.tsx and workspace Playwright flows
 */

import type { ReactNode } from 'react';
import { CreateActivityButton } from '../../../modules/activities';
import type { WorkspaceSectionActionContext } from '../types';

export function agentASectionActions(context: WorkspaceSectionActionContext): ReactNode {
  if (context.role !== 'teacher' || context.section !== 'act') return null;
  if (context.surface === 'desktop-list') return null;
  return <CreateActivityButton surface={context.surface} />;
}
